import React from 'react';

import { Link } from 'react-router-dom';

import { InstructionsLoc } from '../../loc/instructions';
import { loc } from '../../lib/loc';

export default function NotFound() {
    return (
        <div style={{ padding: '30px', border: '1px solid #ECECEC', textAlign: 'center' }}>
            <img src={process.env.REACT_APP_PATH + 'public/img/question-icon.svg'} style={{ marginBottom: '15px' }} alt={''} />
            <div style={{ fontSize: '18px', lineHeight: '22px', textTransform: 'uppercase', textAlign: 'center', marginBottom: '15px' }}>
                {loc(InstructionsLoc.notFound.title)}
            </div>
            <div style={{ fontSize: '14px', lineHeight: '23px', textAlign: 'center' }}>{loc(InstructionsLoc.notFound.detail)}</div>
            <div className="profile-card__wrap-btn">
                <Link className="custom-btn" to="/chat/">
                    {loc(InstructionsLoc.notFound.button)}
                </Link>
            </div>
        </div>
    );
}
